import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const sectionsService = {
  getFaq: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getFaq,
      payload,
      headers,
      hasErrorHandler,
    }),
  getBlogs: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getBlogs,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCheapestFlights: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCheapestFlights,
      payload,
      headers,
      hasErrorHandler,
    }),
  getPopularAirports: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getPopularAirports,
      payload,
      headers,
      hasErrorHandler,
    }),
  getPopularAirlines: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getPopularAirlines,
      payload,
      headers,
      hasErrorHandler,
    }),
  getPopularRoutes: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getPopularRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCampaigns: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCampaigns,
      payload,
      headers,
      hasErrorHandler,
    }),
  decidePageType: (
    query = "",
    params = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.sections.decidePageType,
      payload: { query, ...params },
      headers,
      hasErrorHandler,
    }),

  getRouteCheapestRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getRouteCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCheapestAlternativeRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCheapestAlternativeRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCalendarOneWay: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCalendarOneWay,
      payload,
      headers,
      hasErrorHandler,
    }),
  getPopularAirlinesLanding: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getPopularAirlinesLanding,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCityDynamicText: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCityDynamicText,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCityDynamicQuestion: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCityDynamicQuestion,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFlightRouteDynamicQuestion: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getFlightRouteDynamicQuestion,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFlightRouteDynamicText: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getFlightRouteDynamicText,
      payload,
      headers,
      hasErrorHandler,
    }),
  getGetCityNeighbors: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getGetCityNeighbors,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCityGetCheapestRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCityGetCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirlineDynamicText: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirlineDynamicText,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirlineGetPopularRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirlineGetPopularRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirlineGetInformation: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirlineGetInformation,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirlineGetAirlinePromotions: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirlineGetAirlinePromotions,
      payload,
      headers,
      hasErrorHandler,
    }),
  getGetPopularDestinations: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirlineGetPopularDestinations,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirlineGetOtherAirlines: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirlineGetOtherAirlines,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirlineDynamicQuestionAnswer: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirlineDynamicQuestionAnswer,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCityBlogs: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCityBlogs,
      payload,
      headers,
      hasErrorHandler,
    }),
  getContinentCheapestRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getContinentCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getContinentPopularCountries: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getContinentPopularCountries,
      payload,
      headers,
      hasErrorHandler,
    }),
  getContinentPopularCities: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getContinentPopularCities,
      payload,
      headers,
      hasErrorHandler,
    }),
  getContinentPopularAirlines: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getContinentPopularAirlines,
      payload,
      headers,
      hasErrorHandler,
    }),
  getContinentBlogs: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getContinentBlogs,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCountryCheapestRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCountryCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCountryPopularCities: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCountryPopularCities,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCountryNeighbors: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCountryNeighbors,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCountriesPopularAirlines: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCountriesPopularAirlines,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCountryDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCountryDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCountryBlogs: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCountryBlogs,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCountryInformation: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCountryInformation,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirportCheapestRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirportCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirportPopularAirlines: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirportPopularAirlines,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirportDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirportDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirportPopularCarCompanies: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirportPopularCarCompanies,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAirportsBlogs: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAirportsBlogs,
      payload,
      headers,
      hasErrorHandler,
    }),
  getInternationalFlightDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getInternationalFlightDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),
  getDomesticFlightDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getDomesticFlightDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAllAirlinesDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAllAirlinesDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAllAirportsDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getAllAirportsDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCompanyDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCompanyDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),

  getCommercialDynamicContent: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCommercialDynamicContent,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCommercialCheapestRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCommercialCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCommercialPageConfig: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCommercialPageConfig,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCommercialInformation: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCommercialInformation,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCommercialCampaigns: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCommercialCampaigns,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCommercialFeaturedHotels: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.sections.getCommercialFeaturedHotels,
      payload,
      headers,
      hasErrorHandler,
    }),

  getFlightListingResults: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightResults.getFlightListingResults,
      payload,
      headers,
      hasErrorHandler,
    }),
  getNextDayCheapFlightMessage: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightResults.getNextDayCheapFlightMessage,
      payload,
      headers,
      hasErrorHandler,
    }),
  getDontMissCheapFlightMessage: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightResults.getDontMissCheapFlightMessage,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCheapestBus: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightResults.getCheapestBus,
      payload,
      headers,
      hasErrorHandler,
    }),
  getActiveCampaigns: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightResults.getActiveCampaigns,
      payload,
      headers,
      hasErrorHandler,
    }),
  allocateFlight: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightResults.allocateFlight,
      payload,
      headers,
      hasErrorHandler,
    }),
  getActiveBasket: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightAllocate.getActiveBasket,
      payload,
      headers,
      hasErrorHandler,
    }),
};
